var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotSensorDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.09,
    height: 24.629,
    viewBox: "0 0 23.09 24.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.026 1.812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3373.229,315.118a24.4,24.4,0,0,0,4.394,6.03,13.853,13.853,0,0,1,2.794,4.211,7.131,7.131,0,0,1-1.471,7.7,7.4,7.4,0,0,1-5.809,2.643,7.6,7.6,0,0,1-6.719-3.995c-1.74-2.984-1.229-5.891.739-8.554,1.354-1.832,2.923-3.5,4.33-5.3A32.24,32.24,0,0,0,3373.229,315.118Z",
    transform: "translate(-3365.358 -313.888)",
    fill: "#9fddff",
    stroke: "#417eba",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3378.388,318.118c.712-.867,1.156-1.388,1.675-2.089s.976-1.425,1.461-2.141c.378.585.72,1.188,1.132,1.739.852,1.144,1.8,2.218,2.6,3.4a5.164,5.164,0,0,1-.143,6.5,15.789,15.789,0,0,1-1.928,1.687,5.634,5.634,0,0,0-1.141-4.39C3380.371,320.459,3379.117,319.706,3378.388,318.118Z",
    transform: "translate(-3365.358 -313.888)",
    fill: "#9fddff",
    stroke: "#417eba",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotSensorDrop);
export default __webpack_public_path__ + "static/media/iotSensorDrop.33de5f872874c078c11381a20d5e9d3f.svg";
export { ForwardRef as ReactComponent };